import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../axiosConfig";
import { SubiektTaskResponse } from "../../types/SubiektTaskTypes";

// Result of an open task may come any moment, so it is asked about often
const OPEN_TASK_REFETCH_INTERVAL = 3000;

export default function useGetTask(id: number | null, enabled: boolean) {
  return useQuery({
    queryKey: ["subiektTask", id],
    queryFn: async () => {
      return axiosInstance.get(`/subiekt/tasks/${id}`).then((res) => res.data);
    },
    select: (data: SubiektTaskResponse) => data,
    enabled: enabled && id !== null,
    refetchInterval: (query) => {
      const status = (query.state.data as SubiektTaskResponse | undefined)?.task
        ?.status;
      return status === "pending" || status === "in_progress"
        ? OPEN_TASK_REFETCH_INTERVAL
        : false;
    },
    retry: false,
  });
}
